/* eslint-disable no-unused-vars */
import React from 'react';
import { logger } from './logger';
import { Typography } from '../ppui';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    logger.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI to show when an error occurs
      return <Typography>Something went wrong. Please try again later.</Typography>;
    }

    return this.props.children; // Render children if no error
  }
}

export default ErrorBoundary;
